import { apiClient, unwrap } from '@/lib/apiClient';
import type { ApiSuccess } from '@/types/api';
import type { Subject, SubjectList, SubjectListParams, SubjectPayload } from '@/types/subject';

/**
 * Every call the Subjects page makes.
 *
 * No school id in any path: the server takes it from the caller's token, so
 * there is nothing here that could point at another school's list. Whether a
 * name is the same subject as one already there is the server's decision too.
 */
export const subjectsApi = {
  /** The whole list — tens of subjects — with the per-category counts. */
  list: (params: SubjectListParams = {}) =>
    unwrap(apiClient.get<ApiSuccess<SubjectList>>('/institute/subjects', { params })),

  create: (payload: SubjectPayload) =>
    unwrap(apiClient.post<ApiSuccess<Subject>>('/institute/subjects', payload)),

  /** A new category moves the subject in every class that lists it, too. */
  update: (uuid: string, payload: Partial<SubjectPayload>) =>
    unwrap(apiClient.patch<ApiSuccess<Subject>>(`/institute/subjects/${uuid}`, payload)),

  /** A soft delete that also takes it off every class teaching it this year. */
  suspend: (uuid: string) => unwrap(apiClient.delete<ApiSuccess<null>>(`/institute/subjects/${uuid}`)),

  reinstate: (uuid: string) =>
    unwrap(apiClient.post<ApiSuccess<Subject>>(`/institute/subjects/${uuid}/reinstate`)),
};
